import * as mutateDate from "./mutateDate.js";
import * as mutateCell from "./mutateCell.js";
import { store } from "../../store";
import moment from "../../plugins/moment";

let today = new Date();

export function checkToday(dateFrom) {

  const day1 = dateFrom.getDate()+'/'+dateFrom.getMonth()+'/'+dateFrom.getFullYear();
  const day2 = today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear();

  return day1 === day2;
}

export function checkInRange(dateFrom, dateTo, dateCheck) {
  let inRange = false;
  if (dateFrom.getFullYear() === dateCheck.getFullYear() || dateTo.getFullYear() === dateCheck.getFullYear()) {
    inRange =
      (dateCheck.getDate() >= dateFrom.getDate() ||
        dateCheck.getTime() >= dateFrom.getTime()) &&
      (dateCheck.getMonth() >= dateFrom.getMonth() ||
        dateCheck.getTime() >= dateFrom.getTime()) &&
      (dateCheck.getDate() <= dateTo.getDate() ||
        dateCheck.getTime() <= dateTo.getTime()) &&
      (dateCheck.getMonth() <= dateTo.getMonth() ||
        dateCheck.getTime() <= dateTo.getTime());
  }

  return inRange || false;
}

export function checkFirst(dateFrom, dateCheck) {
  return dateCheck.getDate() === dateFrom.getDate();
}

export function checkLast(dateTo, dateCheck) {
  return dateCheck.getDate() === dateTo.getDate();
}

export function firstHighDate(date) {
  let firstHighDate = new Date(firstDayAvaliable.getTime());
  let lastHighDate = new Date(
    mutateDate.addDays(firstDayAvaliable, 4).getTime()
  );
  let isFirstHighDate = checkInRange(firstHighDate, lastHighDate, date);

  return isFirstHighDate;
}

export function checkPastDate(date, firstDayAvaliable) {
  let result = date.getTime() < firstDayAvaliable.getTime();
  return result;
}

export function checkTypeDateAttribute(dates, day, cell, loading = false, extraPercentage = 0) {
  var day = moment(day).format("L");

  let dateType = dates.filter(date => {
    const dayFromDates = moment(date.day).format('L');
    if(dayFromDates == day) return date;
  })[0];

  if (dateType) {
    mutateCell.addAttributeId(cell, dateType);
    mutateCell.addAttributePrice(cell, dateType, loading, extraPercentage);
  } else {
    cell.classList.add("disabled", "none-before");
  }
}

export function checkTypeDateSelected(dates, day, cell) {
  var day = moment(day).format("L");

  let dateType = dates.filter(date => {
    const dayFromDates = moment(date.day).format('L');
    if(dayFromDates == day) return date;
  })[0];
  if (dateType) {
    requestAnimationFrame(() => {
      cell.classList.add(dateType.type);
    });
  } else {
    requestAnimationFrame(() => {
      cell.classList.add("none");
    });
  }
}

export function checkTypeToMutation(dates, day) {
  day = mutateDate
    .addDays(day, 1)
    .toISOString()
    .split("T")[0];

  let dateType = dates.filter(date => date.day === day)[0];
  if (dateType) {
    return dateType.type;
  } else {
    return "none";
  }
}

export function checkPreviousMonth(currentMonth, currentYear) {
  const previousBtn = document.getElementById("previousBtn");
  if (
    today.getMonth() === currentMonth &&
    today.getFullYear() === currentYear
  ) {
    previousBtn.classList.add("disabled");
  } else {
    previousBtn.classList.remove("disabled");
  }
}
